import { IExpense } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id?: string
	categoryId?: string
	search?: string
	searchFields?: string[]
	pagination?: {
		page: number
		limit: number
	}
	fetch?: {
		category: boolean
	}
}

export async function expenseListApi(payload: RequestDataShape, token?: null | string) {
	const endpoint = "/expense/list/v1"
	const requester = new ApiRequester<RequestDataShape, IExpense[]>(endpoint)
	return await requester.sendRequest(payload, token)
}
